export const ENTITLEMENTS_SUB_TABS = {
    ACCOUNT_ENTITLEMENTS: {
        name: 'account-entitlements',
        caption: 'Entitlements',
    },
    DATASET_ENTITLEMENTS: {
        name: 'dataset-entitlements',
        caption: 'Dataset Entitlements',
    },
    MCP_ENTITLEMENTS: {
        name: 'mcp-entitlements',
        caption: 'MCP Entitlements',
    },
};
